<script>import { Locale } from "../../../i18n/translatable.js";
import {
  dictionaries,
  lookupMessage
} from "../../../i18n/index.js";
import CheckBox from "../../../components/form/helper/CheckBox.svelte";
import {} from "./i18n/index.js";
import FormField from "../../forms/FormField.svelte";
import Swatch from "../../../components/legend/Swatch.svelte";
export let locale = Locale.en;
export let value;
export let color;
export let signal;
$:
  dictionary = dictionaries[locale] ?? dictionaries.en;
const propertyTitle = (key, dictionary2) => lookupMessage(`schema.signal-plot-config.properties.${key}`, dictionary2) ?? "unknown";
</script>

<div class="configurator">
  <div class="caption">
    <div class="title"><Swatch {color} type={'circle'}/>&nbsp;{`${signal}`}</div>
    <div class="use">      <FormField bind:value={value["use"]} let:contextKey={ck0} on:changed>
      <CheckBox story="switch.yesno" contextKey={ck0} />
    </FormField>
</div>
  </div>
  <form>
    <!--div class="form-field">
      <FormField bind:value={value["use"]} let:contextKey={ck0} on:changed>
        <span class="field-label">{propertyTitle("use", dictionary)}</span
        ><CheckBox story="switch.yesno" contextKey={ck0} />
      </FormField>
    </div-->
    {#if !value.noThreshold}
    <div class="form-field">
      <FormField bind:value={value["showThreshold"]} disabled={!value.use} let:contextKey={ck1} on:changed>
        <span class="field-label"
          >{propertyTitle("showThreshold", dictionary)}</span
        ><CheckBox story="switch.eyes" contextKey={ck1} />
      </FormField>
    </div>
    <div class="form-field">
      <FormField bind:value={value["showProjection"]} disabled={!value.use || !value.showThreshold} let:contextKey={ck2} on:changed>
        <span class="field-label"
          >{propertyTitle("showProjection", dictionary)}</span
        ><CheckBox story="switch.eyes" contextKey={ck2} />
      </FormField>
    </div>
    <div class="form-field">
      <FormField bind:value={value["showHistogram"]} name={'showHistogram'} disabled={!value.use || !value.showThreshold} let:contextKey={ck3} on:changed>
        <span class="field-label"
          >{propertyTitle("showHistogram", dictionary)}</span
        ><CheckBox story="switch.eyes" contextKey={ck3} />
      </FormField>
    </div>
    {/if}
  </form>
</div>

<style>
  .configurator {
    margin: 1rem 0.5rem;
  }
  .caption {
    font-weight: 700;
    font-size: 18px;
    display: flex;
    margin-bottom: 1em;
  }

  .caption .title{
    flex-grow:1;
  }
  

  .form-field {
    display: flex;
    margin-bottom: 0.5rem;
  }
  .field-label {
    font-weight: 700;
    font-size: 1rem;
    display: inline-block;
    margin-right: 0.5em;
    text-align: right;
    width: 100px;
    color: #6BAE85;
  }
</style>
